import { reactive } from "vue";

const state = reactive({ from: "" });

export default { state };
